export default __webpack_public_path__ + "static/media/Menu_Beanie.a27c75da.svg";